import dj from "dayjs"

const commonFormat = "YYYY-MM-DD HH:mm:ss"
export const timeArr = [
  {
    label: "今天",
    value: [
      dj()
        .startOf("day")
        .format(commonFormat),
      dj().format(commonFormat)
    ]
  },
  {
    label: "昨天",
    value: [
      dj()
        .startOf("day")
        .subtract(1, "day")
        .format(commonFormat),
      dj()
        .startOf("day")
        .format(commonFormat)
    ]
  },
  {
    label: "本周",
    value: [
      dj()
        .startOf("week")
        .format(commonFormat),
      dj().format(commonFormat)
    ]
  },
  {
    label: "上周",
    value: [
      dj()
        .startOf("week")
        .subtract(1, "week")
        .format(commonFormat),
      dj()
        .startOf("week")
        .format(commonFormat)
    ]
  },
  {
    label: "本月",
    value: [
      dj()
        .startOf("month")
        .format(commonFormat),
      dj().format(commonFormat)
    ]
  },
  {
    label: "上月",
    value: [
      dj()
        .startOf("month")
        .subtract(1, "month")
        .format(commonFormat),
      dj()
        .startOf("month")
        .format(commonFormat)
    ]
  }
]
